import $ from 'jquery';
import './slick-carousel';
import customPaging from './slick/custom-paging';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import throttle from 'lodash/throttle';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'slickSlider';

const slideNum = 5;

export const DEFAULTS = {
	infinite: false,
	accessiblePaging: false,
  slidesToShow: slideNum,
  slidesToScroll: slideNum,
	responsive: [],
  lazyLoad: 'ondemand',
};

let slickID = 1;

/**
* Merges together all the options and the various conditions in which they
* can be set.
* @param  {jQuery} $el - The container element
* @param  {Object} [options={}] - Any options provided upon initialization
* @return {Object} Immutable version of the options
*/
const mergeOptions = ($el, $carouselPrevHTML, $carouselNextHTML, options = {}) => {
	let numSlides = options.slidesToShow;
	//if width is smaller than its default then change num of slides to 4
	let customPagingOpt = {};
	if(options.accessiblePaging) {
		customPagingOpt = { customPaging }
	}
	if($el.width() < 717) {
			numSlides = 4;
	}
	if($el.width() < 769) {
		 numSlides = 4;
	}
	const updateOpts = {
			nextArrow: $carouselNextHTML,
			prevArrow: $carouselPrevHTML,
			slidesToShow: numSlides,
	}
let opts = $.extend({}, DEFAULTS, $el.data(), updateOpts, customPagingOpt, options );
return opts;
};

const initSlick = ( $carouselTrack, options = {}) => {
	  $carouselTrack.slick(options);
};

const getViewportBottomFoldPos = () => {
    return $(window).scrollTop() + $(window).height();
}
const getSlickTopPos = ($el) => {
    const slickPos = $el.offset();
    return slickPos.top;
}

const destroySlick = ($carouselTrack) => {
	const isInitialized = $carouselTrack.hasClass('slick-initialized');
	if(isInitialized) {
		$carouselTrack.slick('unslick');
	}
};

const removeEventListeners = (thisSlickID) => {
  $(window).off(`scroll.slickslider${thisSlickID}`);
};

const destroy = ($carouselTrack, thisSlickID, deregister) => {
  removeEventListeners(thisSlickID);
  destroySlick($carouselTrack);
  deregister();
};

const checkSlickInit = ($el) => {
    return $el.hasClass('slick-initialized');
}
const checkScrollPosition = (thisSlickID, $carouselTrack, options = {}) => {
    const offsetLazyLoad = 150;
    const viewportBottomFoldPos = getViewportBottomFoldPos();
    const slickTopPos = getSlickTopPos($carouselTrack);
    const isSlickInit = checkSlickInit($carouselTrack);
    if (slickTopPos < (viewportBottomFoldPos + offsetLazyLoad) && !isSlickInit) {
        $(window).off(`scroll.slickslider${thisSlickID}`);
        initSlick($carouselTrack, options);
    }
};

const getTrack = ($el) => $el.find(".js-carousel__track, .product-recs").css({'display':'block'});
const getPrev = ($el) => $el.find(".js-carousel__prev");
const getNext = ($el) => $el.find('.js-carousel__next');

export default function slickSlider(el, options = {}, { deregister } = noopActions) {
    const $el = $(el);
    const $carouselTrack = getTrack($el);
    const $carouselPrevHTML = getPrev($el);
    const $carouselNextHTML = getNext($el);
		const opts = mergeOptions($el, $carouselPrevHTML, $carouselNextHTML, options);
    const thisSlickID = slickID;
    checkScrollPosition(thisSlickID, $carouselTrack, opts);
    $(window).on(`scroll.slickslider${thisSlickID}`, throttle(() => {
        checkScrollPosition(thisSlickID, $carouselTrack, opts);
    }, 50));
    slickID++;
		return {
			checkPosition: () => checkScrollPosition(thisSlickID, $carouselTrack, opts),
			destroy: () => destroy($carouselTrack, thisSlickID, deregister),
		};
}

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, slickSlider);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slick-slider.js